import React from 'react'
import { Link } from 'react-router-dom'
import { FaLinkedin, FaInstagram } from 'react-icons/fa'
import '../styles/components/Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo-container">
              <img src="/figo-logo9.png" alt="Figo Digital Services" className="footer-logo" />
              <div className="footer-logo-text">
                <span className="footer-brand-name">FIGO</span>
                <span className="footer-brand-tagline">DIGITAL SERVICES</span>
              </div>
            </div>
            <p>Transforming businesses through technology and innovation</p>
            <div className="social-links">
              <a href="https://www.linkedin.com/company/111438168" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="https://www.instagram.com/figo_digital_services/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Services</h4>
              <Link to="/services/brand">Brand & Identity</Link>
              <Link to="/services/software">Software Development</Link>
              <Link to="/services/ai">AI & Automation</Link>
              <Link to="/services/transform">Digital Transformation</Link>
              <Link to="/services/ux">UI/UX Design</Link>
              <Link to="/services/data">Data & Analytics</Link>
              <Link to="/services/marketing">Digital Marketing</Link>
              <Link to="/services/security">Cybersecurity</Link>
              <Link to="/services/consulting">IT Consulting</Link>
            </div>

            <div className="footer-column">
              <h4>Company</h4>
              <Link to="/about">About Us</Link>
              <Link to="/case-studies">Case Studies</Link>
              <Link to="/blog">Blog</Link>
              <Link to="/contact">Contact</Link>
            </div>

            <div className="footer-column">
              <h4>Resources</h4>
              <Link to="/blog">Blog</Link>
              <Link to="/case-studies">Case Studies</Link>
              <Link to="/industries">Industries</Link>
            </div>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>© {currentYear} FIGO Digital Services Limited. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
